import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { HorizontalLine } from "@faire/web--source/slate/Layout";
import { Pagination } from "@faire/web--source/slate/Pagination";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
import { useLoggedOutCategoryPagePaginationData } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/hooks/useLoggedOutCategoryPagePaginationData";
export var LoggedOutCategoryPagePagination = function(param) {
    var scrollToTop = param.scrollToTop;
    var paginationData = useLoggedOutCategoryPagePaginationData();
    var getPageLinkHandler = function(pageNumber) {
        var currentFilterPath = getCurrentPath().delete("page");
        if (pageNumber === 1) {
            return currentFilterPath.toString();
        }
        return currentFilterPath.append({
            page: pageNumber.toString()
        }).toString();
    };
    var _paginationData_page_count;
    var shouldShowPagination = paginationData && ((_paginationData_page_count = paginationData.page_count) !== null && _paginationData_page_count !== void 0 ? _paginationData_page_count : 0) > 1;
    if (!shouldShowPagination) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(HorizontalLine, {}),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(Pagination, {
                paginationData: paginationData,
                pageToLink: getPageLinkHandler,
                onChangePage: function(page) {
                    return scrollToTop({
                        toResults: true,
                        toTop: page === 1
                    });
                }
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(HorizontalLine, {})
        ]
    });
};
